import React, { useMemo } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';

// **** Components **** //

/**
 * Default Component
 */
const TabGroup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Only want the first fields for the root level
  const tabGroupPathValue = useMemo(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    return `/${segments[0]}/${segments[1]}`;
  }, [location.pathname]);

  return (
    <TabGroupLib value={tabGroupPathValue} onChange={(path) => navigate(path, { replace: true })}>
      <Tab value={AdminConfigPaths.SITE}>Site Configuration</Tab>
      <Tab value={AdminConfigPaths.Task.root}>Task Configuration</Tab>
      <Tab value={AdminConfigPaths.Form.root}>Work/Requirement Form Configuration</Tab>
      <Tab value={AdminConfigPaths.MODIFICATION}>Task Modification Configuration</Tab>
    </TabGroupLib>
  );
};

// **** Export **** //

export default TabGroup;
